import { useTranslation } from 'react-i18next';
import { Modal, ModalVariant } from '@/components/Modal';
import { I18nNamespace } from '@/lib/i18n-namespaces';

interface ReportEventOrderConfirmationModalProps {
    isOpen: boolean;
    isReordering: boolean;
    onConfirm: () => void;
    onCancel: () => void;
}

export function ReportEventOrderConfirmationModal({
    isOpen,
    isReordering,
    onConfirm,
    onCancel,
}: ReportEventOrderConfirmationModalProps) {
    const { t } = useTranslation(I18nNamespace.REPORTS);

    return (
        <Modal
            isOpen={isOpen}
            title={t('detail.reorder.confirmTitle')}
            description={t('detail.reorder.confirmBody')}
            onCancel={onCancel}
            onSubmit={onConfirm}
            submitInProgress={isReordering}
            submitText={t('detail.reorder.confirm')}
            size="small"
            variant={ModalVariant.PLAIN}
            closeOnOutsideClick
            contentTestId="report-event-order-confirmation"
        />
    );
}
